import { render, staticRenderFns } from "./ColorSelectorSwatches.vue?vue&type=template&id=612c75d4"
import script from "./ColorSelectorSwatches.vue?vue&type=script&lang=js"
export * from "./ColorSelectorSwatches.vue?vue&type=script&lang=js"
import style0 from "./ColorSelectorSwatches.vue?vue&type=style&index=0&id=612c75d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports